import { useEffect, useState } from 'react';

import { TaskApi } from '../../../../../../api';
import { onRequestError } from '../../../../../../services/handlers';

export default function useTaskPriorities() {
  const [taskPriorities, setTaskPriorities] = useState([]);

  useEffect(() => {
    TaskApi.getTaskPriorities()
      .then(({ data: priorities }) => {
        setTaskPriorities(priorities);
      })
      .catch(e => onRequestError(e));
  }, []);

  return taskPriorities;
}
